import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-eb4b0830"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "page-container" }
const _hoisted_3 = { class: "footer-top footer-line" }
const _hoisted_4 = { class: "footer-section" }
const _hoisted_5 = { class: "footer-get-started" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-get-started-title" }, "Ready to Get Started?", -1))
const _hoisted_7 = { class: "footer-get-started-buttons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button primary" }, "Browse Courses", -1))
const _hoisted_9 = {
  key: 0,
  class: "button default"
}
const _hoisted_10 = { class: "footer-navigation" }
const _hoisted_11 = { class: "footer-list" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-list-title" }, "Main Menu", -1))
const _hoisted_13 = { class: "footer-list-items" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-list-item" }, "Blog", -1))
const _hoisted_15 = { class: "footer-list" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-list-title" }, "Support", -1))
const _hoisted_17 = { class: "footer-list-items" }
const _hoisted_18 = { class: "footer-list" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-list-title" }, "Account", -1))
const _hoisted_20 = {
  key: 0,
  class: "footer-list-items"
}
const _hoisted_21 = {
  key: 1,
  class: "footer-list-items"
}
const _hoisted_22 = { class: "footer-bottom footer-line" }
const _hoisted_23 = { class: "footer-section" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "footer-copyright" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-section" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: { name: $setup.routesName.coursesList }
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                to: { name: $setup.routesName.registration }
              }, {
                default: _withCtx(() => [
                  (!$setup.isLoggedIn)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_9, "Join for Free"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_router_link, {
                class: "footer-list-item",
                to: { name: $setup.routesName.coursesList }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Courses")
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                class: "footer-list-item",
                to: { name: $setup.routesName.centersList }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Learning Centers")
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                class: "footer-list-item",
                to: { name: $setup.routesName.partners }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Partner With Us")
                ]),
                _: 1
              }, 8, ["to"]),
              _hoisted_14
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_router_link, {
                class: "footer-list-item",
                to: { name: $setup.routesName.faq }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Have Questions?")
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                class: "footer-list-item",
                to: { name: $setup.routesName.privacyPolicy }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Privacy policy")
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                class: "footer-list-item",
                to: { name: $setup.routesName.terms }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Terms")
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                class: "footer-list-item",
                to: { name: $setup.routesName.contactUs }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Contact Us")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            ($setup.isLoggedIn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_router_link, {
                    class: "footer-list-item",
                    to: { name: $setup.routesName.dashboard }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Dashboard")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    class: "footer-list-item",
                    to: { name: $setup.routesName.myCourses }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("My Courses")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    class: "footer-list-item",
                    to: { name: $setup.routesName.myCertificates }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("My Certificates")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    class: "footer-list-item",
                    to: { name: $setup.routesName.myTranscript }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("My Transcript")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    class: "footer-list-item",
                    to: { name: $setup.routesName.myProfile }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("My Profile")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    class: "footer-list-item",
                    to: { name: $setup.routesName.mySettings }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("My Settings")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(_component_router_link, {
                    class: "footer-list-item",
                    to: { name: $setup.routesName.login }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Login")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    class: "footer-list-item",
                    to: { name: $setup.routesName.registration }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Register")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_router_link, {
            to: { name: $setup.routesName.landing }
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: $setup.logoSrc,
                alt: "nexusmedx"
              }, null, 8, _hoisted_24)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_25, "© " + _toDisplayString($setup.currentYear) + " Nexus MedX. All rights reserved.", 1)
        ]),
        _hoisted_26
      ])
    ])
  ]))
}